import React, { Component } from "react";
import withServices from "src/HOCs/withServices";
import Loader from "react-loader";
import { Redirect } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import NavBar from "../../components/CustomNav/CustomNav.Component";
import { Container, ResetForm } from "./ResetPassword.styles";

interface Props {
  services: any;
  history: any;
  location: any;
}

interface IState {
  token: string;
  tokenStatus: string;
  toLogin: boolean;
  loaded: boolean;
  newPassword: string;
  resetLoaded: boolean;
  resetSuccess: boolean;
}

class ResetPassword extends Component<Props, IState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      token: "",
      tokenStatus: "",
      toLogin: false,
      loaded: false,
      newPassword: "",
      resetLoaded: false,
      resetSuccess: false,
    };

    this.setNewPasswordHandler = this.setNewPasswordHandler.bind(this);
  }

  public async componentDidMount() {
    const token: any = new URLSearchParams(this.props.location.search).get(
      "token"
    );
    if (token === null) {
      toast.error("Invalid Link, try again");
      setTimeout(() => {
        this.setState({ toLogin: true });
      }, 5000);
    }
    const validateRes = await this.props.services.adminAPI.validatePasswordResetToken(
      { token }
    );

    if (validateRes.ok) {
      this.setState({
        loaded: true,
        token,
        tokenStatus: validateRes.data.status,
      });
    } else {
      this.setState({ tokenStatus: "notfound", loaded: true });
    }
  }

  public inputChangeHandler = (e) => {
    console.log(e.target.value);
    this.setState({ newPassword: e.target.value });
  };

  public goBack = () => {
    this.setState({ toLogin: true });
  };

  public async setNewPasswordHandler(e) {
    e.preventDefault();
    const { token, newPassword } = this.state;
    const item = {
      password: newPassword,
      token,
    };
    const resetRes = await this.props.services.adminAPI.confirmPasswordReset(
      item
    );
    if (resetRes.ok) {
      this.setState({ resetSuccess: true, resetLoaded: true });
    } else {
      this.setState({ resetLoaded: true, resetSuccess: false });
    }
    console.log(JSON.stringify(resetRes, null, 2));
  }

  public renderResetContent = () => {
    const { loaded, tokenStatus } = this.state;
    console.log(loaded + " " + tokenStatus + " " + this.state.toLogin);
    if (loaded) {
      let content;
      if (tokenStatus === "OK") {
        content = (
          <ResetForm>
            <h1 className="reset-pass">Reset Password</h1>
            <p>Enter and submit a new password below </p>
            <input
              required={true}
              type="password"
              className="custom-textfield"
              placeholder="New Password"
              onChange={this.inputChangeHandler}
            />
            <button
              type="submit"
              className="green-button login-button"
              onClick={this.setNewPasswordHandler}
            >
              Set new Password
            </button>
          </ResetForm>
        );
      } else {
        content = (
          <ResetForm>
            <h1 className="invalid-link">
              This reset link is no longer invalid, go back and get a new one!
            </h1>
            <div className="fail-icon">
              <i className="fa fa-ban reset-fail" style={{ fontSize: "40px" }} />
            </div>
            <button className="red-button login-button" onClick={this.goBack}>
              Go Back
            </button>
          </ResetForm>
        );
      }
      return content;
    } else {
      return (
        <ResetForm>
          <Loader color="#acff24" loaded={loaded} />
        </ResetForm>
      );
    }
  };

  public renderSuccess = () => {
    const { resetLoaded, resetSuccess } = this.state;
    if (resetLoaded) {
      if (resetSuccess) {
        return (
          <ResetForm>
            <h1 className="reset-success">Password reset successful</h1>
            <p>Your password has been reset, you can now login</p>
            <div className="success-icon">
              <i className="fa fa-check reset-passs" style={{ fontSize: "40px" }} />
            </div>
            <button className="login-button green-button">Login</button>{" "}
          </ResetForm>
        );
      } else {
        return (
          <ResetForm>
            <h1 className="reset-success">Password reset failed</h1>
            <p>Your reset session expired, go back and try again</p>
            <div className="fail-icon">
              <i className="fa fa-ban" style={{ fontSize: "40px" }} />
            </div>
            <button className="login-button green-button" onClick={this.goBack}>GO back</button>{" "}
          </ResetForm>
        );
      }
    } else {
      return (
        <ResetForm>
          <Loader color="#acff24" loaded={resetLoaded} />
        </ResetForm>
      );
    }
  };

  public render() {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    return (
      <div style={{ height: "100vh", width: "100vw" }}>
        <ToastContainer />
        <NavBar />
        <Container>{ this.state.resetSuccess ? this.renderSuccess() : this.renderResetContent()}</Container>
      </div>
    );
  }
}

export default withServices(ResetPassword);



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/ResetPassword.Component.tsx